import { fetch } from 'utils/api';

export function api_fetchAllJurisdictions(ids) {
  return fetch({
    url: `/all_jurisdictions`,
    dataType: 'Jurisdictions',
    method: 'GET'
  });
}
